import { render, staticRenderFns } from "./contentTagEdit.vue?vue&type=template&id=1d07772c&"
import script from "./contentTagEdit.vue?vue&type=script&lang=js&"
export * from "./contentTagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports